/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useForm } from "react-hook-form";
import { Button } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { SidebarTextField } from "~/components/SidebarForm/inputs/SidebarTextField";
import { SidebarForm } from "~/components/SidebarForm/SidebarForm";
import { SidebarFormButtons } from "~/components/SidebarForm/SidebarFormButtons";
import { showSuccess } from "~/components/Toast";
import {
  generateActionSuccessText,
  itHasNotOnlyWhitespace,
  useAxios,
} from "~/tools";
import { maxLength } from "~/tools/validation/validators";

export default function ({ refetch }: { refetch: () => Promise<void> }) {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const methods = useForm();

  const { showError } = useShowError();
  const { Axios } = useAxios();

  const onSubmit = async (values: { name: string }) => {
    setLoading(true);
    try {
      await Axios().post("/service-offerings", values);
      showSuccess(
        generateActionSuccessText(`Service offering ${values.name}`)()(
          "added"
        )()
      );
      setLoading(false);
      setIsSidebarOpen(false);

      return refetch();
    } catch (e) {
      showError(e.response);
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        onClick={() => setIsSidebarOpen(true)}
        css={{ marginLeft: "auto" }}
        icon="plus"
      >
        Add new service offering
      </Button>

      <SidebarForm
        title="Add new service offering"
        open={isSidebarOpen}
        setOpen={setIsSidebarOpen}
        formMethods={methods}
        submit={onSubmit}
      >
        <SidebarTextField
          name="name"
          label="Name"
          required
          registerOptions={{
            ...maxLength(100),
            validate: itHasNotOnlyWhitespace,
          }}
        />

        <SidebarFormButtons
          submitText="Add"
          submitEnabled={!!methods.watch("name")}
          submitLoading={loading}
          onCancel={() => setIsSidebarOpen(false)}
        />
      </SidebarForm>
    </>
  );
}
